import React from 'react';
import { Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { Banner, isCreativityBanner } from '../../../types/banner';
import { SubtitlesReviewCard } from './fields/subtitles-review-card';

const { Text } = Typography;

interface ReviewPanelProps {
  banner: Banner;
  onReviewSubmitted?: () => void;
}

export const ReviewPanel: React.FC<ReviewPanelProps> = ({ banner, onReviewSubmitted }) => {
  if (!isCreativityBanner(banner) || !banner.reviewFields) {
    return (
      <div style={{ padding: '40px 20px', textAlign: 'center', color: '#64748b' }}>
        <CheckCircleOutlined style={{ fontSize: 48, color: '#10b981', marginBottom: 16 }} />
        <Text style={{ display: 'block', fontSize: 15 }}>No hay elementos pendientes de revisión</Text>
      </div>
    );
  }

  const hasPendingReviews = Object.values(banner.reviewFields).some(field => field?.status === 'pending');

  if (!hasPendingReviews) {
    return (
      <div style={{ padding: '40px 20px', textAlign: 'center', color: '#64748b' }}>
        <CheckCircleOutlined style={{ fontSize: 48, color: '#10b981', marginBottom: 16 }} />
        <Text style={{ display: 'block', fontSize: 15 }}>Todos los elementos han sido revisados</Text>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20, padding: 10 }}>
      <div
        style={{
          background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
          border: '1px solid #fbbf24',
          borderRadius: 12,
          padding: '16px 20px',
          display: 'flex',
          alignItems: 'flex-start',
          gap: 12
        }}
      >
        <div style={{ pointerEvents: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 8 }}>
            <div
              style={{
                width: 20,
                height: 20,
                background: '#f59e0b',
                borderRadius: '50%',
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontWeight: 'bold',
                fontSize: 14
              }}
            >
              !
            </div>
            <Text strong style={{ fontSize: 14, color: '#92400e', display: 'block', marginBottom: 4 }}>
              Hay elementos que requieren tu revisión
            </Text>
          </div>
          <Text style={{ fontSize: 13, color: '#b45309', lineHeight: 1.5 }}>
            Los siguientes campos fueron generados automáticamente. Revisalos y confirmalos para continuar con el
            procesamiento.
          </Text>
        </div>
      </div>

      {/* Subtitles Review */}
      {banner.reviewFields.subtitles?.status === 'pending' && (
        <SubtitlesReviewCard
          bannerId={banner.bannerId}
          subtitles={banner.reviewFields.subtitles}
          onSubmitted={onReviewSubmitted}
        />
      )}
    </div>
  );
};
